import { registerPlugin } from '@capacitor/core';
import { runtime } from './runtime';

const passwords = registerPlugin('PasswordSaving');
// Only successful password login calls this. Never persist or log these values.
export async function offerPasswordSaving(username, password) {
    if (runtime.platform() !== 'ios' || ![true, 'true'].includes(import.meta.env.VITE_NATIVE_PASSWORD_SAVING_ENABLED)) return;
    try { await passwords.save({ username, password }); }
    catch { /* Cancelling or unavailable password saving must not fail sign-in. */ }
}
